module.exports = __webpack_public_path__ + "img/sfondo-blu-gradiente.5aadb1ff.jpg";